<template>
  <slot></slot>
  <modal :id="modalId" :title="title">
    <form :id="formId" :action="actionUrl" method="POST" role="form">

      <div v-if="toggleStatus">
        <p>Are you sure you want to {{ toggleActionName }} <em>'{{ data.name }}'</em>?</p>
      </div>
      <div v-else>
        <div class="form-group row">
          <label for="inputName" class="col-sm-2 col-form-label">Name:</label>
          <div class="col-sm-10">
            <input type="text" name="name" id="inputName" class="form-control" required="required" v-model="data.name" placeholder="List item display name">
          </div>
        </div>

        <div class="form-group row">
          <label for="inputDescription" class="col-sm-2 col-form-label">Description:</label>
          <div class="col-sm-10">
            <input type="text" name="description" id="inputDescription" class="form-control" v-model="data.description" placeholder="Description to store in the database">
          </div>
        </div>

        <div class="form-group row" v-if="isField !== null">
          <label for="inputDescription" class="col-sm-2 col-form-label">Type:</label>
          <div class="col-sm-10 mt-1" v-if="isNew">
            <label class="radio-inline mr-2">
              <input type="radio" name="is_field" value="field" v-model="data.isField" checked> Field
            </label>
            <label class="radio-inline mr-2">
              <input type="radio" name="is_field" value="desk" v-model="data.isField"> Desk
            </label>
            <label class="radio-inline">
              <input type="radio" name="is_field" value="both" v-model="data.isField"> Both
            </label>
          </div>
          <div class="col-sm-10 mt-2" v-else>
            <div class="label label-warning inline-block" v-if="data.isField">Field</div>
            <div class="label label-success inline-block" v-else>Desk</div>
          </div>
        </div>
      </div>

      <input type="hidden" name="_method" :value="method">
      <input type="hidden" name="_token" :value="$csrf_token">
    </form>

    <template #footer>
      <template v-if="toggleStatus">
        <button type="button" class="btn btn-default" @click.prevent="cancelStatusToggle($event)"><i class="fa fa-fw fa-ban"></i> Cancel</button>
        <button type="submit" class="btn btn-danger" :form="formId" v-if="data.status"><i class="fa fa-fw fa-toggle-off"></i> Disable</button>
        <button type="submit" class="btn btn-primary" :form="formId" v-else><i class="fa fa-fw fa-toggle-on"></i> Enable</button>
      </template>
      <template v-else>
        <template v-if="isExisting">
          <button type="button" class="btn btn-danger mr-auto" v-if="data.status" @click.prevent="confirmStatusToggle"><i class="fa fa-fw fa-toggle-off"></i> Disable</button>
          <button type="button" class="btn btn-primary mr-auto" v-else @click.prevent="confirmStatusToggle"><i class="fa fa-fw fa-toggle-on"></i> Enable</button>
        </template>
        <button type="button" class="btn btn-default" @click="hideModal"><i class="fa fa-fw fa-ban"></i> Close</button>
        <button type="submit" class="btn btn-primary" :disabled="isEmpty" :form="formId"><i class="fa fa-fw fa-upload"></i> Save changes</button>
      </template>
    </template>

  </modal>

</template>

<style scoped>
</style>

<script>

  import HasModal from "../mixins/HasModal";

  export default {
    mixins: [HasModal],

    props: {

      id: {
        type: Number,
        default: 0
      },
      name: {
        type: String,
        default: ''
      },
      description: {
        type: String,
        default: ''
      },
      status: {
        type: Boolean,
        default: true
      },
      // Experience type
      isField: {
        type: Boolean,
        default: null
      },
      action: {
        type: String,
        default: ''
      },
      actionToggleStatus: {
        type: String,
        default: ''
      },
      // Custom id for modal component.
      modalId: {
        type: String,
        default: 'lookup-adjuster-item-modal'
      },
    },

    data() {

      return {
        data: {
          id: this.id,
          name: this.name,
          description: this.description,
          status: this.status,
          isField: this.isField,
          action: this.action,
          actionToggleStatus: this.actionToggleStatus,
        },
        toggleStatus: false,
      };

    },
    computed: {
      formId() {
        return this.modalId + '-form';
      },
      title() {
        if (this.toggleStatus) {
          return this.data.status ? 'Disable Adjuster list item' : 'Enable Adjuster list item';
        }
        return this.isNew ? "Add Adjuster list item" : "Edit Adjuster list item";
      },
      method() {
        if (this.toggleStatus) return 'PATCH';
        return this.isNew ? "POST" : "PATCH";
      },
      actionUrl() {
        if(this.toggleStatus) return this.data.actionToggleStatus;
        return this.data.action;
      },
      hasData() {
        return !!(this.data.name && this.data.name.trim().length);
      },
      isEmpty() {
        return !this.hasData;
      },
      isExisting() {
        return this.data.id > 0;
      },
      isNew() {
        return !this.isExisting;
      },
      toggleActionName() {
        return this.data.status ? 'disable' : 'enable';
      },
    },
    methods: {
      confirmStatusToggle() {
        this.toggleStatus = true;
      },
      cancelStatusToggle(e) {
        this.toggleStatus = false;
      },
    }
  }

</script>
